import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const NotificationSkeleton = () => {
  return (
    <div className="wn-page">

      {/* Header Skeleton */}
      <div className="wn-mob-header">

        <Skeleton
          circle
          width={42}
          height={42}
        />

        <Skeleton
          width={170}
          height={26}
        />

      </div>

      {/* Notifications Skeleton */}
      <div className="wn-list">

        {Array.from({ length: 6 }).map((_, index) => (
          <div
            className="wn-card"
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px"
            }}
          >
            <Skeleton
              circle
              width={48}
              height={48}
            />

            <div style={{ flex: 1 }}>

              <Skeleton
                height={18}
                width="45%"
              />

              <Skeleton
                height={14}
                width="85%"
                style={{ marginTop: 8 }}
              />

              <Skeleton
                height={12}
                width="35%"
                style={{ marginTop: 8 }}
              />

            </div>

          </div>
        ))}

      </div>

    </div>
  );
};

export default NotificationSkeleton;